import React, { useEffect, useRef,useContext } from 'react'
import { UserContext } from '../OEMChanges/OemAssetsImport';
import { Link, useHistory } from 'react-router-dom';
import navarrow from "../assets/back_btn.png";
// import walletIcon from "../assets/wallet.png"
import Cross from '../assets/Redeem-revamp/Cross.svg'
// import './TransactionSummary.css'
import TransactionItem from './TransactionItem';
import { getTranscationSummeryDetails } from '../Services/userService';
import NewClose from "../assets/revamp-assets/closeMark.png"
import { useState } from 'react';
import { timespans, transactionTypesData, allFilters,transactionTypesData1, allFilters1 } from './TransactionData';
import Loading from '../models/Loading';
import { createAdminPageURL, createOEMAdminPageURL, WebToNativeMessage } from '../Common/Utils';
import leftArrow from './assets/leftArrow.png';
import rightArrow from './assets/rightArrow.png';

const TransactionSummary = () => {
    const [checkAll, setCheckAll] = useState(false)
    const [recordsPerPage] = useState(50)
    const [leftIndex, setLeftIndex] = useState(0)
    const [rightIndex, setRightIndex] = useState(recordsPerPage - 1)
    const [page, setPage] = useState(1)
    const [pagesArray, setPagesArray] = useState([1])
    const [totalPages, setTotalPages] = useState(1)
    const [expandedIndex, setExpandedIndex] = useState(null)
    const [loading, setLoading] = useState(true)
    const [filterMenu, setFilterMenu] = useState(false)
    const [filterSection, setFilterSection] = useState('transaction')
    const [transactionTypes, setTransactionTypes] = useState(sessionStorage.getItem("channel").toLowerCase() !== "oemaps1" ? transactionTypesData : transactionTypesData1)
    const [timespan, setTimespan] = useState(7)//Before 1
    const [timeWords, setTimeWords] = useState('Today')
    const [appliedTimespan, setAppliedTimespan] = useState(7) //Before 1
    const [selectedFilters, setSelectedFilters] = useState(['All'])
    const [appliedFilters, setAppliedFilters] = useState(['All'])
    const [transactionData, setTransactionData] = useState([])
    const [mappedData, setMappedData] = useState([])
    const [appliedFilterCount, setAppliedFilterCount] = useState(1)
    const [userBalance, setUserBalance] = useState(null)
    const [enableHeader, setEnableHeader] = useState(true)
    const [showDefaultReferral,setShowDefaultReferral] = useState(false)
    const [showTDSIframe,setShowTDSIframe] = useState(false)
    const pageRef = useRef(null)
    const history = useHistory()
    console.log("channel in ts page",sessionStorage.getItem("channel") === "OEMAPS1")
    const assets = useContext(UserContext);
    console.log(assets ,"is assets in transaction summary");
    // if(sessionStorage.getItem("channel") === "OEMAPS1"){
    //     console.log("ekjfjbnf",)
    //     import ('./TransactionSummaryOEM.css');
    // }else{
    //     import('./TransactionSummary.css');
    // }
    // let isoemps = sessionStorage.getItem("channel") === "OEMAPS1"
    const [isoemps,setIsoemps] = useState(false)

    useEffect(() => {
        setIsoemps(sessionStorage.getItem("channel") === "OEMAPS1")
        if (sessionStorage.getItem("channel") === "OEMAPS1") {
        //   import('./TransactionSummaryOEM.css');
        console.log("came into OEMAPS1")
        import('./TransactionSummaryOEM.css');
        } else {
            console.log("came into APS")
          import('./TransactionSummary.css');
        }
      }, [])
    const handle_ts_back_click = () => {
        WebToNativeMessage({
            type: "redeemCTEvent", eventName: "PF_c_Back_Click_mywallet_viewalltransactions", eventProperties: {
                acelevel: window.sessionStorage["aceLevel"],
                channel: window.sessionStorage["channel"],
                subscriptionType: window.sessionStorage["subscriptionType"],
                userId: window.sessionStorage["userid"],
                username: window.sessionStorage["screenName"],
                wallet_balance: window.sessionStorage["totalBalance"],
                Clicklocation: 'TransactionSummary'
            }
        })
        if (window.sessionStorage["isfrom"] === 'wallet' && window.sessionStorage["referClickLocation"]!=='ReferralBonus') {
            history.push('/walletinfo')
        } else {
            WebToNativeMessage({ type: 'closeClient' })
        }
    }

    const getReferralTransactionData = async () => {
        setLoading(true)
        console.log('Getting new data with time: hhhhhhhhhhhhhh ', 30, ' and filters: ',['Referral Bonus']);
        setAppliedFilterCount(1)
        setSelectedFilters(['Referral Bonus'])
        setAppliedFilters(['Referral Bonus'])
        setTimespan(30)
        setAppliedTimespan(30)
        setCheckAll(false)
        setFilterMenu(false)
        const results = await getTranscationSummeryDetails(window.sessionStorage["token"], 30, ['Referral Bonus'], window.sessionStorage["userid"])
            .then((res) => {
                console.log('Results are: ', res.data)
                // console.log('Total Records: ', res.data.transactionHistory.length)
                setUserBalance(res.data.userClosingBal);
                setTransactionData(res.data.transactionHistory.sort((a, b) => a.createdAt > b.createdAt ? -1 : 1))
                setMappedData(res.data.transactionHistory.slice(0, recordsPerPage - 1))
                let totalPages = Math.ceil(res.data.transactionHistory.length / recordsPerPage)
                // console.log('Total Pages are: ', totalPages)
                let pagesArray = []
                for (let i = 1; i <= totalPages; i++) {
                    pagesArray.push(i)
                }
                setPagesArray(pagesArray)
                setTotalPages(totalPages)
                setExpandedIndex(null)
                setLoading(false)
                setShowDefaultReferral(true)
            })
    }

    const createTDSIframe = ()=>{
        return(<div style={{ position: "fixed", width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',top:'0px',left:"0px", zIndex: '99999' }}>
        <div style={{ position: 'absolute', width: '100%', height: '100%', background: "rgba(0,0,0,0.5)" }} onClick={() => setShowTDSIframe(false)}></div>
        <div style={{ display: "flex", flexDirection: 'column', position: "absolute", width: "95%", height: "80%", justifyContent: "center", alignItems: "center", overflow: "hidden", backgroundColor: 'white'}}>
            <div style={{ width: "100%", background: "#032146", color: "#FFFFFF", height: "7%", display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem', fontWeight: '700' }}>TDS
                <img src={assets?.assets?.Cross} alt='close' style={{ position: "absolute", right: "5%" }} onClick={() => setShowTDSIframe(false)} />
            </div>
            <div style={{ width: '100%', height: '93%' }}>
                <iframe style={{ paddingTop: "", marginTop: "", marginBottom: "", height: "100%", width: "100%", overflow: "scroll" }} height="100%" width="100%" title="" overflowy="scroll" src={createOEMAdminPageURL(process.env.REACT_APP_REAL_STATIC_WEB_URL , process.env.REACT_APP_OEMWEB_BASE_URL ,  "tds.html?src=mapp&header=N&t=" + Math.random() , isoemps)}>
                </iframe>
            </div>
        </div>

    </div>)
    }

    const getTransactionSummaryData = async (all) => {
        // Make API call here with array of transaction types and timespan.
        setLoading(true)
        console.log('Getting new data with time: ', timespan, ' and filters: ', selectedFilters, all);
        const results = await getTranscationSummeryDetails(window.sessionStorage["token"], timespan, (all !== undefined && all !== null) ? all : selectedFilters, window.sessionStorage["userid"])
            .then((res) => {
                // console.log('Results are: ', res.data)
                // console.log('Total Records: ', res.data.transactionHistory.length)
                setUserBalance(res.data.userClosingBal);
                setTransactionData(res.data.transactionHistory.sort((a, b) => a.createdAt > b.createdAt ? -1 : 1))
                setMappedData(res.data.transactionHistory.slice(0, recordsPerPage - 1))
                let totalPages = Math.ceil(res.data.transactionHistory.length / recordsPerPage)
                // console.log('Total Pages are: ', totalPages)
                let pagesArray = []
                for (let i = 1; i <= totalPages; i++) {
                    pagesArray.push(i)
                }
                setPagesArray(pagesArray)
                setTotalPages(totalPages)
                setExpandedIndex(null)
                setLoading(false)
            })
    }

    const closeFilterMenu = () => {
        setFilterMenu(false)
        setSelectedFilters(appliedFilters)
        setTimespan(appliedTimespan)
        setCheckAll(false)
    }

    const handleFilterApply = () => {
        // Apply button is inactive if selectedFilters length is 0. So minimum will always be 1.
        setAppliedFilterCount(selectedFilters.length)
        setAppliedFilters(selectedFilters)
        setCheckAll(false)
        setAppliedTimespan(timespan)
        setFilterMenu(false)
        getTransactionSummaryData()
    }

    const clearAllFunction = () => {
        setSelectedFilters(["All"])
        setAppliedFilters(["All"])
        // setTimespan(1)
        // Changing applied filter to get new transaction data
        if (appliedFilters.length === 1) {
            getTransactionSummaryData(['All'])
        }
        setAppliedFilterCount(1)
        // console.log('CLEARED')
    }

    const handleTransactionTypes = (e) => {
        let transactionType = e.target.value;
        let checked = e.target.checked;
        console.log('SELECTED FILTER IS: ', e.target.name)
        // alert('SELECTED FILTER IS: ', e.target.name)
        if (checked) {
            WebToNativeMessage({
                type: "redeemCTEvent", eventName: "PF_c_Filter_transaction_Click_viewalltransactions", eventProperties: {
                    acelevel: window.sessionStorage["aceLevel"],
                    channel: window.sessionStorage["channel"],
                    subscriptionType: window.sessionStorage["subscriptionType"],
                    userId: window.sessionStorage["userid"],
                    username: window.sessionStorage["screenName"],
                    wallet_balance: window.sessionStorage["totalBalance"],
                    option_selected: e.target.name,
                }
            })
            let filters = selectedFilters.filter((type) => type !== 'All');
            if (!filters.includes(transactionType)) {
                filters.push(transactionType)
            }

            console.log("filters are: ", filters);
            console.log("filters are: 1", allFilters);
            console.log("filters are: 2", filters.length);
            console.log("filters are: 3", allFilters.length);
            console.log("filters are: 4", allFilters1);
            console.log("filters are: 5", allFilters1.length);

            setSelectedFilters(filters)


            if(sessionStorage.getItem("channel").toLowerCase() !== "oemaps1"){
                if (filters.length === allFilters.length) {
                    setCheckAll(true)
                    setSelectedFilters(['All'])
                }
            }else{
                if (filters.length === allFilters1.length) {
                    setCheckAll(true)
                    setSelectedFilters(['All'])
                }
            }
           
        } else {
            if (selectedFilters.includes('All')) {
                let filters = sessionStorage.getItem("channel").toLowerCase() !== "oemaps1" ? allFilters.filter((type) => type !== transactionType) : allFilters1.filter((type) => type !== transactionType);
                setSelectedFilters(filters)
            } else {
                let filters = selectedFilters.filter((type) => type !== transactionType);
                setSelectedFilters(filters)
            }
            setCheckAll(false)
        }
    }

    const handleAllCheck = (e) => {
        let checked = e.target.checked;
        if (checked) {
            setCheckAll(true)
            setSelectedFilters(['All'])
        } else {
            setCheckAll(false)
            setSelectedFilters([])
        }
    }

    const handleLeftPage = () => {
        if (page === 1) {
            return
        } else {
            setPage(page - 1)
            let leftIdx = leftIndex - recordsPerPage;
            let rightIdx = rightIndex - recordsPerPage;
            setLeftIndex(leftIndex - recordsPerPage)
            setRightIndex(rightIndex - recordsPerPage)
            setExpandedIndex(null)
            setMappedData(transactionData.slice(leftIdx, rightIdx))
        }
        window.scrollTo(0, 0)
    }

    const handleRightPage = () => {
        if (page === totalPages) {
            return
        } else {
            let leftIdx = leftIndex + recordsPerPage;
            let rightIdx = rightIndex + recordsPerPage;
            setPage(page + 1)
            setLeftIndex(leftIndex + recordsPerPage)
            setRightIndex(rightIndex + recordsPerPage)
            setExpandedIndex(null)
            setMappedData(transactionData.slice(leftIdx, rightIdx))
        }
        window.scrollTo(0, 0)
    }

    const handlePageClick = (item) => {
        if (item !== page) {
            let leftIdx = recordsPerPage * (item - 1);
            let rightIdx = recordsPerPage * (item - 1) + recordsPerPage;
            // console.log('New Left Index: ', leftIdx);
            // console.log('New Right Idx: ', rightIdx);
            setLeftIndex(leftIdx);
            setRightIndex(rightIdx);
            setExpandedIndex(null)
            setMappedData(transactionData.slice(leftIdx, rightIdx))
            setPage(item)
            window.scrollTo(0, 0)
        }
        return
    }

    const handleDateChange = (e) => {
        WebToNativeMessage({
            type: "redeemCTEvent", eventName: "PF_c_Filter_date_Click_viewalltransactions", eventProperties: {
                acelevel: window.sessionStorage["aceLevel"],
                channel: window.sessionStorage["channel"],
                subscriptionType: window.sessionStorage["subscriptionType"],
                userId: window.sessionStorage["userid"],
                username: window.sessionStorage["screenName"],
                wallet_balance: window.sessionStorage["totalBalance"],
                option_selected: e.target.name,
            }
        })
        let selectedDate = Number(e.target.value);
        setTimespan(selectedDate)
    }

    useEffect(() => {
        // Getting Transaction Data on Mount and on applied filter change.

        // getTransactionSummaryData()

        if(showDefaultReferral===false && window.sessionStorage["referClickLocation"]==='ReferralBonus'){
            getReferralTransactionData()
        }
        else{
            getTransactionSummaryData()
        }

        // This will not trigger if only one filter is applied, as the count does not change. eg: Add Cash (1) to All (1).
        // The 1 to 1 case is explicitly handled in the clearAll function.
        // console.log("While transaction summary >>>>>>>>>");

        WebToNativeMessage({
            type: "redeemCTEvent", eventName: "PF_c_transummary_pageload", eventProperties: {
                acelevel: window.sessionStorage["aceLevel"],
                channel: window.sessionStorage["channel"],
                subscriptionType: window.sessionStorage["subscriptionType"],
                userId: window.sessionStorage["userid"],
                wallet_balance: window.sessionStorage["totalBalance"],
            }
        })

    }, [appliedFilterCount])

    useEffect(() => {
        if (filterMenu) {
            pageRef.current.style.position = 'fixed'
            pageRef.current.style.backgroundColor = isoemps ? "rgba(21,25,31)" :'white'
            pageRef.current.style.width = '100%'
        } else {
            pageRef.current.style.position = ''
            pageRef.current.style.backgroundColor = isoemps ? "rgba(21,25,31)" :'white'
            pageRef.current.style.width = '100%'
            // pageRef.current.style.width = '100%'
        }
    }, [isoemps,filterMenu])

    useEffect(() => {
        if (showTDSIframe) {
            pageRef.current.style.position = 'fixed'
            pageRef.current.style.backgroundColor = 'white'
            pageRef.current.style.width = '100%'
        } else {
            pageRef.current.style.position = ''
            pageRef.current.style.backgroundColor = 'white'
            pageRef.current.style.width = '100%'
            // pageRef.current.style.width = '100%'
        }
    }, [showTDSIframe])

    useEffect(() => {
        const searchParams = (window.location.href).split('enableHeader=')[1]
        setEnableHeader(searchParams)
    }, [])

    useEffect(()=>{
        WebToNativeMessage({"type":"ScreenNameEventForUXCam","screenName":"Transaction_Summary_Page"}) // for UXCam
    },[])

    return (
        // Transaction Summary Page
        <div className='TransactionSummaryPage'>
            {/* TS Sticky Header */}
            <div className='ts-sticky-header'>
                {/* TS Header / Navbar */}
                {
                    enableHeader !== 'N' ?
                        <div className='transactionSummaryHeader'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img style={{ width: '40px' }} src={assets?.assets?.navarrow} onClick={() => handle_ts_back_click()}></img>
                                <span className='ts-nav-text' style={{ marginLeft: '16px' }}>All Transactions</span>
                            </div>
                            {
                            userBalance ?
                                <div className='ts-walletInfo'>
                                    <img style={{ width: '15px' }} src={assets?.assets?.walletIcon1}></img>
                                    <span style={{ marginLeft: '5px', position: 'relative', top: '2px' }}>&#8377;{Number(userBalance).toFixed(2)}</span>
                                </div>
                                :
                                null
                            }
                        </div>
                        :
                        null
                }
                {/* TS Filter Header Section */}
                <div className='ts-filters'>
                    <div className='ts-list-header'>
                        {console.log("appliedTimespan",timespans)}
                        <span>{timespans.filter((item) => item.value === appliedTimespan)[0].name}</span>
                    </div>
                    <div className='ts-controls'>
                        {
                            (selectedFilters.length >= 1 && !selectedFilters.includes('All')) ?
                                <>
                                    <div className='clear-control' onClick={() => clearAllFunction()}>
                                        <span>Clear All</span>
                                    </div>
                                    <div className='filter-divider'>
                                    </div>
                                </>
                                :
                                null
                        }
                        <div className='filter-control'>
                            <span onClick={() => setFilterMenu(true)}>Filter By</span>
                            {/* Number of filters div in RED */}
                            {
                                (appliedFilters.length > 1 || (appliedFilters.length == 1 && appliedFilters[0] !== 'All')) &&
                                <div className='filterNumber'>{appliedFilterCount}</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className='ts-no-scroll-div' ref={pageRef}>
                {
                    loading ?
                        <div style={{
                            position: "absolute",
                            width: '100%',
                            height: '100vh',
                            top:0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <Loading />
                        </div>
                        :
                        <>
                            {/* Transaction Summary Records */}
                            <div className={mappedData.length !== 0 ? 'ts-records-container2': "ts-records-container1"}>
                                <div className='ts-records'>
                                    {mappedData.length !== 0 ?
                                        mappedData.map((item, index) => {
                                            console.log("item in transaction summary",item)
                                            return (<TransactionItem data={item} key={index + Math.random()} index={index} expand={expandedIndex === index} setExpandedIndex={(val) => setExpandedIndex(val)} setShowTDSIframe={(val)=>setShowTDSIframe(val)} />)
                                        })
                                        :
                                        <div className='ts-no-records'>No transaction found to display</div>
                                    }
                                </div>
                            </div>

                            <div className='ts-pagination'>
                                {
                                    totalPages > 1 ?
                                        <div className='ts-pagination-controls' style={{ marginBottom: '10px' }}>
                                            <img onClick={() => handleLeftPage()} className='ts-pag-arrow' src={page === 1 ? assets?.assets?.leftArrow : assets?.assets?.rightArrow} style={{ transform: page !== 1 && 'scaleX(-1)' }}></img>
                                            {(page === 1) ?
                                                pagesArray.slice(0, 3).map((item, index) => {
                                                    return (
                                                        <div onClick={() => handlePageClick(item)} className={page === item ? 'active-page-num ts-page-num' : 'ts-page-num'} key={index + Math.random()}>
                                                            {item}
                                                        </div>
                                                    )
                                                }) :
                                                (page === totalPages) ?
                                                    pagesArray.slice(pagesArray.length - 3 >= 0 ? pagesArray.length - 3 : 0, totalPages + 1).map((item, index) => {
                                                        return (
                                                            <div onClick={() => handlePageClick(item)} className={page === item ? 'active-page-num ts-page-num' : 'ts-page-num'} key={index + Math.random()}>
                                                                {item}
                                                            </div>
                                                        )
                                                    }) :
                                                    pagesArray.slice(page - 2, page + 1).map((item, index) => {
                                                        return (
                                                            <div onClick={() => handlePageClick(item)} className={page === item ? 'active-page-num ts-page-num' : 'ts-page-num'} key={index + Math.random()}>
                                                                {item}
                                                            </div>
                                                        )
                                                    })
                                            }
                                            <img onClick={() => handleRightPage()} className='ts-pag-arrow' src={page === totalPages ? assets?.assets?.leftArrow : assets?.assets?.rightArrow} style={{ transform: page === totalPages && 'scaleX(-1)' }}></img>
                                        </div>
                                        :
                                        null
                                }
                                <div className='ts-cs-email'>
                                    <span>For more than 1 month summary, request at </span><span className="emailWeb" href="" onClick={() => WebToNativeMessage({ type: 'email' })}>{isoemps ? "black@a23.com" : "info@a23.com"} </span>
                                </div>
                            </div>
                        </>
                }
            </div>
            {showTDSIframe && createTDSIframe()}
            {/* Filter Menu */}
            {
                filterMenu &&
                <div className='ts-filter-slider-wrapper' style={{}}>
                    <div className='filter-slider-top-div' onClick={() => closeFilterMenu()}></div>
                    <div className='ts-filter-menu'>
                        <div className='ts-filter-menu-relative'>
                            <div className='ts-filter-header'>
                                <span>Apply Filter</span>
                                <img id="ts_close" onClick={() => closeFilterMenu()} src={assets?.assets?.Cross}></img>
                            </div>
                            <div className='ts-filter-menu-body'>
                                <div className='ts-filter-sections'>
                                    <div className='ts-filter ts-filter-transaction-type' style={{ backgroundColor: (filterSection === 'transaction' ? isoemps ? "rgba(53, 59, 71, 1)" : 'white' : 'transparent') }} onClick={() => setFilterSection('transaction')}>
                                        <span id="ts_transaction">Transactions</span>
                                    </div>
                                    <div id="ts_date" className='ts-filter ts-filter-timespan' style={{ backgroundColor: filterSection === 'date' ? isoemps ? "rgba(53, 59, 71, 1)" : 'white' : 'transparent' }} onClick={() => setFilterSection('date')}>
                                        <span >Date</span>
                                    </div>
                                </div>
                                <div className='ts-filter-values'>
                                    {
                                        filterSection === 'transaction' ?
                                            <div className='ts-transaction-types'>
                                                {
                                                    transactionTypes.map((type) => {
                                                        if (type.value === 'All') {
                                                            return (
                                                                <div className='ts-type' key={type.name + Math.random()}>
                                                                    <input type="checkbox" id={type.name} name={type.name} value={type.value} onChange={(e) => handleAllCheck(e)} defaultChecked={checkAll} />
                                                                    <label className='ts-label' style={{ fontWeight: type.name === 'Select All' ? 'bold' : null }} htmlFor={type.name}>{type.name}</label><br></br>
                                                                </div>
                                                            )
                                                        } else {
                                                            return (
                                                                <div className='ts-type' key={type.name + Math.random()}>
                                                                    <input type="checkbox" id={type.name} name={type.name} value={type.value} defaultChecked={selectedFilters.includes(type.value) || checkAll === true} onChange={(e) => handleTransactionTypes(e)} />
                                                                    <label className='ts-label' style={{ fontWeight: type.name === 'Select All' ? 'bold' : null }} htmlFor={type.name}>{type.name.toLowerCase() === "acepoint redeem" ? type.name : type.name.toLowerCase().replace(/redeem/g,"Withdrawal")  }</label><br></br>
                                                                </div>
                                                            )
                                                        }
                                                    })
                                                }
                                            </div>
                                            :
                                            <div className='ts-transaction-dates'>
                                                {
                                                    timespans.map((type, index) => {
                                                        return (
                                                            <div className='ts-date' key={type.name + Math.random()}>
                                                                <input type="radio" id={type.name} name={type.name} value={type.value} onChange={(e) => handleDateChange(e)} defaultChecked={timespan === type.value} />
                                                                <label className='ts-label' htmlFor={type.name}>{type.name}</label><br></br>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                    }
                                </div>
                            </div>
                            {/* Apply Button */}
                            <div className='apply-filter-div'>
                                {
                                    selectedFilters.length !== 0 && (selectedFilters !== appliedFilters || timespan !== appliedTimespan) ?
                                        <button className='applyButton' onClick={() => handleFilterApply()}>Apply</button>
                                        :
                                        <button className='btn-grey'>Apply</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
        

    )
}

export default TransactionSummary